import {PageHeader, AdvancedTableOptions} from '~/components'
import {TABLE_INFO} from '~/components/advanced_table/instances/billing_infos/constants'

export const BillingInfosPageHeader = () => {
	return <PageHeader label="common.billing_infos" right={<AdvancedTableOptions {...TABLE_INFO} />} />
}
